import AddressMacTagList from "@/component/tag/AddressMacTagList.tsx";
import { DateHelper } from "@/constant/helper.ts";
// Download JSON file UI removed (no make_json_config in DB)
import { DownloadFileButton } from "@/view/license/component/DownloadFileButton.tsx";
import { Descriptions } from "antd";
import { useTranslation } from "react-i18next";

const LicenseRegistrationInfo = ({
  info,
}: {
  info?: LicenseRegistrationDetail;
}) => {
  const { t } = useTranslation();
  const optionNames = [
    "EDEV",
    "ETEST",
    "Cobol To Java",
    "Delphi To C#",
    "JSP To Thymeleaf",
    "o3w xml To Spring Web",
    "ASP To JSP",
    "VB.net To Java",
    "VBScript To Java",
    "TODO",
    "TODO",
    "TODO",
    "TODO",
    "TODO",
    "TODO",
    "TODO",
    "TODO",
    "TODO",
  ];
  const selectedLicenses = (info?.checkboxes ?? [])
    .map((checked, index) => (checked ? optionNames[index] : null))
    .filter((value): value is string => Boolean(value));

  return (
    <Descriptions
      labelStyle={{
        fontSize: 16,
        color: "#172635",
        fontWeight: 500,
        width: 200,
      }}
      contentStyle={{
        color: "#556476",
        fontSize: 16,
      }}
      colon={false}
      column={2}
      items={[
        {
          key: "firstName",
          label: t("field.firstName"),
          children: info?.firstName,
        },
        {
          key: "productName",
          label: t("field.productName"),
          children: info?.productName,
        },
        {
          key: "lastName",
          label: t("field.lastName"),
          children: info?.lastName,
        },
        {
          key: "duration",
          label: t("field.duration"),
          children: info?.duration,
        },
        {
          key: "companyName",
          label: t("field.companyName"),
          children: info?.companyName,
        },
        {
          key: "expirationDate",
          label: "Valid Date",
          children: info?.expirationDate
            ? DateHelper.convertDateToStringDate(info?.expirationDate)
            : "----/--/--",
        },
        {
          key: "departmentName",
          label: t("field.departmentName"),
          children: info?.departmentName,
        },
        {
          key: "licensingTo",
          label: "Licensing to",
          children:
            selectedLicenses.length > 0 ? selectedLicenses.join(", ") : "-",
        },
        {
          key: "numberOfLicense",
          label: t("field.numberOfLicense"),
          children: info?.numberOfLicense,
        },
        {
          key: "email",
          label: t("field.email"),
          children: info?.registrantEmail,
        },
        {
          key: "addressMac",
          label: t("field.addressMac"),
          children: (
            <span>
              <AddressMacTagList addressMac={info?.addressMac} />
            </span>
          ),
        },
        {
          key: "mobile",
          label: t("field.mobile"),
          children: info?.registrantMobile,
        },
        {
          key: "downloadLicense",
          label: t("button.download"),
          children: (
            <DownloadFileButton
              disabled={!info?.license}
              url={
                info?.licenseRegistrationId
                  ? `/license-registration/download/${info?.licenseRegistrationId}`
                  : undefined
              }
              fileName={`license.lic`}
            />
          ),
        },
      ]}
    />
  );
};

export default LicenseRegistrationInfo;
